/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, Component } from "react";
import { MenuOutlined } from "@ant-design/icons";
import SideNav from "./sidenav";
import Noti from "./notification";
import NotificationBoldGroup from "./NotificationBoldGroup";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { changeLang } from "../actions/langAction";
import { setOperation } from "../actions/operationdataAction";
import { Link } from "react-router-dom";
import ChangePath from "../services/ServiceApi";
import Api from "../services/ServiceApi";
import Action from "../actions/NotificationHistoryAction";
import { notification } from "antd";
import { setMasterLang, setfactUpdate } from "../actions/masterLangAction";
import NewSideNav from "../components/sideNav/sideNav";
import NotificationSound from "../assets/sound-files/bell-notification.wav";
import { withRouter } from "react-router";
import { isMobile } from "react-device-detect";

const SwitchNotification = ({ companyId }) => {
  return <>{companyId + "" === "1" ? <Noti /> : <NotificationBoldGroup />}</>;
  // return <NotificationBoldGroup />;
};
class LayoutOperation extends Component {
  constructor(props) {
    super(props);
    // super(props);
    this.state = {
      loading: true,
      active: false,
      noti: false,
      hasNoti: false,
      username: Cookies.get("username"),
      type: [
        {
          value: 1,
          text: "Digital",
          operatorid: 1,
        },
      ],
      setUrl: "",
      operator: [],
      master_language: [],
      logopath: Cookies.get("logopath"),
      currentOperatorid: 3,
      projectData: [],
      filterProjectdata: [],
      IntervalGetNotificationHistory: null,
      operator_id: this.props.match.params.operator_id,
      projectId: this.props.match.params.project_id,
    };
  }
  audio = new Audio(NotificationSound);

  async setOperationData() {
    const operationData = JSON.parse(Cookies.get("operation"));
    let typeValue = [];
    for (const i in operationData.operation_data) {
      let valueData = {
        value: operationData.operation_data[i].operator_id,
        text: operationData.operation_data[i].operator_name,
      };
      typeValue.push(valueData);
    }
    let ProjectData = [];
    for (const i in operationData.project_data) {
      let valueProject = {
        value: operationData.project_data[i].operator_id,
        text: operationData.project_data[i].project_name,
      };
      ProjectData.push(valueProject);
    }
    ProjectData.push({ value: 999, text: "All Project" });
    await this.setState({
      type: typeValue,
      projectData: ProjectData,
    });
    /* filter on first load */
    const project = this.state.projectData;
    const filterProjectdata = project.filter((data) => {
      // eslint-disable-next-line eqeqeq
      return data.value == this.state.currentOperatorid;
    });
    this.setState({
      filterProjectdata: filterProjectdata,
    });
  }
  async componentDidMount() {
    if (!Cookies.get("username")) {
      setTimeout(() => {
        window.location.assign(Api.absoluteUrl("/login"));
      }, 500);
    }
    // let { project_id } = this.props.params;
    console.log("project_iddddddd", this.props.match.params.project_id);
    if (Cookies.get("companyid") === "3") {
      if (Cookies.get("authenCheck") !== "True") {
        Cookies.remove("companyid");
        Cookies.remove("authenCheck");
        notification.error({
          message: "Verify Code Error",
          description: "Verify Code Error",
        });
        setTimeout(() => {
          window.location.assign(Api.absoluteUrl("/login"));
        }, 1500);
      }
    }
    if (
      Cookies.get("locale") !== undefined
      // &&
      // Cookies.get("locale") !== Cookies.get("locale")
    ) {
      this.props.changeLang(Cookies.get("locale"));
    } else {
      Cookies.set("locale", "en");
    }
    const data_language = await Api.post("master_language_detail_get", {
      company_id: parseInt(Cookies.get("companyid")),
      page_id: 1,
    });

    if (
      localStorage.getItem("projectData") === null ||
      localStorage.getItem("projectData") === undefined
    ) {
      this.logoutClicked();
    } else {
      const filterProjectdata = JSON.parse(
        localStorage.getItem("projectData")
      ).filter((data) => {
        // return data.operator_id == operatorId;
        return data.operator_id == Cookies.get("operator_id");
      });
      this.setState({
        operator: JSON.parse(localStorage.getItem("operator")),
        projectData: filterProjectdata,
        master_language: data_language.data.data.masteR_LANGUAGE,
      });
    }
    this.CookiesChecker(window.location.pathname);

    // if (Cookies.get("companyid") + "" !== "1") {
    const { REACT_APP_DELAY_REQUEST_API_MINUTE } = process.env;
    let min_interval = 1;
    const delayRequest = (REACT_APP_DELAY_REQUEST_API_MINUTE || 1) * 60 * 1000;
    this.handleGetNotificationHistory();
    let setIntervalGetNotificationHistory = setInterval(() => {
      this.handleGetNotificationHistory();
    }, delayRequest);
    this.setState({
      IntervalGetNotificationHistory: setIntervalGetNotificationHistory,
    });
    // }
    this.props.setMasterLang(
      JSON.parse(data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json)
    );
    this.props.setfactUpdate(true);
    //this.props.setDynamicMenu(dynamicMenu.data?.data.dynamic_menu);
  }

  handleGetNotificationHistory = () => {
    // Api.get(`notification/gethistory?userId=${480}`).then(
    if (this.state.projectId) {
      Api.get(
        `notification/gethistory?userId=${Cookies.get(
          "userId"
        )}&companyId=${Cookies.get("companyid")}&operatorId=${Cookies.get(
          "operator_id"
        )}&projectId=${this.state.projectId}`
      ).then(({ data: res }) => {
        const { notificationHistory } = this.props;
        const listNotificationId = notificationHistory.notifications.map(
          (s) => s.notificationId
        );
        const filterNotification = res?.data.filter(
          (s) => !listNotificationId.includes(s.notificationId)
        );

        if (notificationHistory.willMount) {
          if (filterNotification.length > 0) {
            this.audio.play();
          }
          filterNotification.forEach((item) => {
            notification.info({
              message: item.title,
              description: item.message,
            });
          });
        }
        this.props.setNotificationHistory(res?.data);
      });
    }
  };

  componentWillUnmount() {
    clearInterval(this.state.IntervalGetNotificationHistory);
  }

  CookiesChecker = (currentlocation) => {
    var PATTERN = "publicwebview";
    const checkUrl = window.location.href.indexOf(PATTERN);

    if (checkUrl === -1) {
      const moduleToken = Cookies.get("OperationToken");
      let identifier = {};
      if (moduleToken) {
        try {
          identifier = ChangePath.post("tokenchecker", {
            TokenUser: moduleToken,
          });
        } catch (error) {
          identifier = error;
        }
        identifier.then((value) => {
          if (value.data.result.value === "P") {
            return null;
          } else {
            return this.logoutClicked();
          }
        });
      } else {
        return this.logoutClicked();
      }
    } else {
      var searchParams = new URLSearchParams(window.location.search);
      Cookies.set("companyid", searchParams.get("company"));
    }
  };
  setLang(locale) {
    Cookies.set("locale", locale.toLowerCase());
    this.props.changeLang(locale.toLowerCase());
  }

  setOperator = (operator_id) => {
    Cookies.set("operator_id", operator_id);
    localStorage.setItem("operator_id", operator_id);
    const filterProjectdata = JSON.parse(
      localStorage.getItem("projectData")
    ).filter((data) => {
      return data.operator_id == operator_id;
    });

    Cookies.set("project_id", filterProjectdata[0].project_id);
    this.setState({
      projectData: filterProjectdata,
    });

    window.location.reload();
  };

  logoutClicked() {
    localStorage.clear();
    Cookies.remove("OperationToken");
    Cookies.remove("companyid");
    window.location.assign(Api.absoluteUrl("/login"));
    // window.location.reload(false);
  }

  setProjectData = (project_id) => {
    Cookies.set("project_id", project_id);
    window.location.reload();
  };

  switchSideNav = () => {
    this.setState({
      active: !this.state.active,
    });

    if (this.state.active == false) {
      document.getElementById("mySidenav").style.width = "200px";
      // document.body.style.backgroundColor = "rgba(0,0,0,0.4)";

      this.setState({
        active: true,
      });
    } else {
      document.getElementById("mySidenav").style.width = "0px";
      // document.body.style.backgroundColor = "rgba(0,0,0,0.4)";

      this.setState({
        active: false,
      });
    }
  };

  render() {
    const { children } = this.props;
    const { active, noti, username, project_id, operator_id } = this.state;
    const projectId = operator_id
      ? project_id
        ? project_id
        : ""
      : Cookies.get("project_id");
    return (
      <Fragment>
        <nav
          className="navbar navbar-expand-lg navbar-light position-fixed"
          style={{ height: "auto", minHeight: "64px" }}
        >
          <Link className="navbar-brand" to="/">
            <img
              src={ChangePath.absoluteUrl("/logo/maxi_operation.png")}
              width={isMobile ? "120" : "180"}
              alt=""
            />
          </Link>
          <ul className="navbar-nav">
            <li className="nav-item">
              <button
                className={
                  active === true
                    ? "nav-link toggle-sidenav active"
                    : "nav-link toggle-sidenav"
                }
                // onClick={() => this.setState({ active: !active })}
                onClick={() => this.switchSideNav()}
              >
                <MenuOutlined />
              </button>
            </li>
          </ul>
          <Link className="navbar-brand collapse navbar-collapse" to="/">
            <img
              src={ChangePath.absoluteUrl(this.state.logopath)}
              width="77"
              // height="36"
              alt=""
              // style={{ width: "54px", height: "21px" }}
            />
          </Link>
          <div className="collapse navbar-collapse fs-16 font-mont-b c-blue justify-content-center w-100 text-uppercase">
            Maintenance
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <a
                  className="nav-link position-relative"
                  onClick={() => this.setState({ noti: !noti })}
                >
                  {this.state.hasNoti ? (
                    <div className="alert-noti position-absolute"></div>
                  ) : (
                    ""
                  )}
                  <img
                    src={ChangePath.absoluteUrl("/icon/notifications.svg")}
                    width="30"
                    alt=""
                  />
                </a>
              </li>
              <li className="nav-item">
                <select
                  style={{
                    height: "30px",
                    fontSize: "16px",
                    width: "80px",
                    marginTop: "10px",
                    paddingLeft: "5px",
                    background: "#F9FAFE",
                    border: "0px",
                  }}
                  className="dropdrowtype font-thai-r"
                  onChange={(e) => this.setOperator(e.target.value)}
                  value={Cookies.get("operator_id")}
                  // value={Cookies.get("operator_id")}
                >
                  {this.state.operator.map((item, index) => (
                    <option
                      value={item.operator_id}
                      key={`layoutoption_${index}`}
                    >
                      {item.operator_name}
                    </option>
                  ))}
                </select>
              </li>
              <li className="nav-item ml-3">
                <select
                  style={{
                    height: "30px",
                    fontSize: "16px",
                    width: "120px",
                    marginTop: "10px",
                    paddingLeft: "5px",
                    background: "#F9FAFE",
                    border: "0px",
                  }}
                  className="dropdrowtype font-thai-r"
                  onChange={(e) => this.setProjectData(e.target.value)}
                  value={projectId}
                >
                  {this.state.projectData.map((item, index) => (
                    <option value={item.project_id} key={`layout_b_${index}`}>
                      {item.project_name}
                    </option>
                  ))}
                </select>
              </li>
              <li className="nav-item ml-3">
                <select
                  style={{
                    height: "30px",
                    fontSize: "16px",
                    width: "80px",
                    marginTop: "10px",
                    paddingLeft: "5px",
                    background: "#F9FAFE",
                    border: "0px",
                  }}
                  className="dropdrowtype font-thai-r"
                  onChange={(e) => this.setLang(e.target.value)}
                  value={
                    Cookies.get("locale") === undefined
                      ? "EN"
                      : Cookies.get("locale").toUpperCase()
                  }
                  // defaultValue={}
                >
                  {this.state.master_language.map((item, index) => (
                    <option value={item.name_short} key={`layout_c_${index}`}>
                      {item.name_long}
                    </option>
                  ))}
                </select>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="h-100 d-flex align-items-center nav-link dropdown-toggle"
                  id="navbarDropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span
                    className="font-mont-m fs-14"
                    style={{ marginTop: "5px", fontSize: "14px" }}
                  >
                    {Cookies.get("username")}
                  </span>
                </a>
                <div
                  className="dropdown-menu"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <Link className="dropdown-item" to="/user-profile">
                    Profile
                  </Link>
                  <a className="dropdown-item" onClick={this.logoutClicked}>
                    Logout
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        {/* <div
          style={{
            position: "fixed",
            display: "flex",
            width: "100%",
            backgroundColor: "#ff9800ab",
            zIndex: 200,
          }}
        >
          <marquee>MaxiOperation จะทำการปิดระบบเพื่อปรับปรุง เวลา 01:00 - 03:00</marquee>
        </div> */}
        <div>{children}</div>
        {/* <div>version 11111</div> */}
        {noti ? (
          <SwitchNotification companyId={Cookies.get("companyid")} />
        ) : null}
        {/* {active ? ( */}
        {Number(Cookies.get("companyid")) === 1 ? (
          <SideNav active={this.props.active} />
        ) : (
          <NewSideNav />
        )}
        {/* ) : null} */}
        {/* {active ? <NewSideNav></NewSideNav> : null} */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  operation: state.operationReducer,
  notificationHistory: state.notificationHistory,
  // willMountNotification: state.willMount,
});

const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setOperation: (data) => dispatch(setOperation(data)),
    setNotificationHistory: (data) =>
      dispatch({ type: Action.SET_NOTIFICATION_HISTORY_LIST, payloads: data }),
    setMasterLang: (data) => dispatch(setMasterLang(data)),
    setfactUpdate: (data) => dispatch(setfactUpdate(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(withRouter(LayoutOperation));
